module.exports = __webpack_public_path__ + "img/13.eb693b78.png";